import moment from 'moment';
import { DatePeriod } from '../../../account/analytics/analytics.constants';
const dummyDataForInitialState = () => {
    const now = moment();
    const amountOfMonthToShow = 12;
    return [...new Array(amountOfMonthToShow)].map((item, index) => ({
        date: now
            .clone()
            .subtract(amountOfMonthToShow - (index + 1), 'months')
            .format('MMMM YYYY'),
        totalSessionPerMonth: 0,
        totalDurationPerMonth: 0,
        averageDurationPerMonth: 0,
    }));
};
export const INITIAL_STATE = {
    averageSessions: 0,
    totalSession: 0,
    totalDuration: 0,
    dataByDate: dummyDataForInitialState(),
    maxDurationInMonth: {
        averageDurationPerMonth: 0,
        date: '',
        totalDurationPerMonth: 0,
        totalSessionPerMonth: 0,
    },
    maxSessionsInMonth: {
        averageDurationPerMonth: 0,
        date: '',
        totalDurationPerMonth: 0,
        totalSessionPerMonth: 0,
    },
    growthInPercent: null,
    overview: {
        averageDurationForOverview: 0,
        totalDurationForOverview: 0,
        totalSessionForOverview: 0,
    },
    filter: {
        providersIds: [],
        roomsIds: [],
        locationIds: [],
    },
    datePeriod: DatePeriod.THIS_MONTH,
};
